import { FlavourColorMap, FlavourNameMap, Flavour } from 'types/Flavour'

export const FLAVOUR_COLORS: FlavourColorMap = { full: '#35b8d3', skimmed: '#f1617d', archive: '' }
export const DEFAULT_FLAVOUR: Flavour = 'full'
export const ALL_FLAVOURS: Flavour[] = ['full', 'skimmed', 'archive']
export const FLAVOUR_TITLES: FlavourNameMap = { full: 'Full fat', skimmed: 'Skimmed', archive: 'Archive' }
export const LEGACY_FLAVOURS: string[] = ['semi']
